import { createSlice } from '@reduxjs/toolkit';
import { Gender } from 'constants/user';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  settings: {
    realName: undefined,
    gender: Gender.NotSelected,
    birthday: undefined,
    isOnHoliday: false,
    username: '',
    isInternationalTradingEnabled: null,
    isDarkMode: false
  },
  uiState: UiState.Idle
};

const setInitialSettings = (draft, action) => {
  draft.settings = action.payload.settings;
};

const setRealName = (draft, action) => {
  draft.settings.realName = action.payload.realName;
};

const setGender = (draft, action) => {
  draft.settings.gender = action.payload.gender;
};

const setBirthday = (draft, action) => {
  draft.settings.birthday = action.payload.birthday;
};

const setIsOnHoliday = (draft, action) => {
  draft.settings.isOnHoliday = action.payload.isOnHoliday;
};

const setIsDarkMode = (draft, action) => {
  draft.settings.isDarkMode = action.payload.isDarkMode;
};

const setUsername = (draft, action) => {
  draft.settings.username = action.payload.username;
};

const setIsInternationalTradingEnabled = (draft, action) => {
  const {
    isInternationalTradingEnabled
  } = action.payload;
  draft.settings.isInternationalTradingEnabled = isInternationalTradingEnabled;
};

const setError = (draft, action) => {
  draft.error = action.payload.error;
};

const changeUiState = (draft, action) => {
  const {
    uiState
  } = action.payload;
  draft.uiState = uiState;
};

const accountSettingsSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setInitialSettings,
    setRealName,
    setGender,
    setBirthday,
    setIsOnHoliday,
    setIsDarkMode,
    setUsername,
    setIsInternationalTradingEnabled,
    setError,
    changeUiState
  }
});
export const {
  actions
} = accountSettingsSlice;
export const plug = {
  [stateName]: accountSettingsSlice.reducer
};
export default accountSettingsSlice.reducer;